angular
  .module('modules', [
    'admin-configuration.module',
    'analysis.module',
    'psa.module',
    'common-directives.module',
    'custom-dashboard.module',
    'dashboard.module',
    'frontpage.module',
    'gridlets-directives.module',
    'login-controllers.module',
    'login-directives.module',
    'configuration-management.module',
    'package-management.module',
    'webtip.module',
    'gridlets.module',
    'users.module',
    'pis-tool.module',
    'access-nothing.module',
    'service-limit.module',
    'key-manager.module',
    'track-condition.module',
    'condition-monitoring.module',
    'logo.module',
    // 'chart.module' TODO: Add when migrating to chart component
  ]);